import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

type TimerProps = {
    className?: string;
};

const Timer: React.FC<TimerProps> = ({ className }) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds((prevSeconds) => prevSeconds + 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const minutes = Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0");
    const restSeconds = (seconds % 60).toString().padStart(2, "0");

    return (
        <div className={className}>
            <div
                className={cn(
                    "flex h-full w-full items-center font-frutigerBold text-[12px] font-bold text-neutral-200 text-shadow-timer-mobile",
                    "md:text-[16px] md:text-shadow-timer-desktop",
                    "4k:text-[64px]"
                )}
            >
                {minutes}:{restSeconds}
            </div>
        </div>
    );
};

export default Timer;
